import { render, staticRenderFns } from "./ExportAchievementData.vue?vue&type=template&id=484db55e&"
import script from "./ExportAchievementData.vue?vue&type=script&lang=js&"
export * from "./ExportAchievementData.vue?vue&type=script&lang=js&"
import style0 from "./ExportAchievementData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports